<template>
    <div :class="cx('root')" :style="sx('root')" v-bind="ptmi('root')">
        <canvas ref="canvas" :width="width" :height="height" @click="onCanvasClick($event)" v-bind="{ ...canvasProps, ...ptm('canvas') }"></canvas>
    </div>
</template>

<script>
import Chart from 'primevue/chart';
import { toRaw } from 'vue';

const cloneChartValue = (value) => {
    const rawValue = toRaw(value);

    if (Array.isArray(rawValue)) {
        return rawValue.map((item) => cloneChartValue(item));
    }

    if (rawValue instanceof Date) {
        return new Date(rawValue);
    }

    if (rawValue && typeof rawValue === 'object') {
        return Object.keys(rawValue).reduce((clonedValue, key) => {
            clonedValue[key] = cloneChartValue(rawValue[key]);

            return clonedValue;
        }, {});
    }

    return rawValue;
};

/**
 * Chart com proteção contra erro "can't acquire context from the given item"
 * ao sair da página. Verifica se o canvas ainda existe antes de inicializar.
 */
export default {
    name: 'SafeChart',
    extends: Chart,
    data() {
        return {
            chartInitVersion: 0,
        };
    },
    beforeUnmount() {
        this.chartInitVersion += 1;
    },
    methods: {
        getChartConfig() {
            return {
                type: this.type,
                data: cloneChartValue(this.data),
                options: cloneChartValue(this.options),
                plugins: cloneChartValue(this.plugins)
            };
        },
        initChart() {
            const initVersion = ++this.chartInitVersion;

            import('chart.js/auto').then((module) => {
                if (initVersion !== this.chartInitVersion || !this.$refs?.canvas) return;

                if (this.chart) {
                    this.chart.destroy();
                    this.chart = null;
                }

                if (module?.default) {
                    this.chart = new module.default(this.$refs.canvas, this.getChartConfig());
                }

                this.$emit('loaded', this.chart);
            });
        },
        reinit() {
            if (!this.chart || this.chart.config?.type !== this.type) {
                this.initChart();

                return;
            }

            const chartConfig = this.getChartConfig();

            this.chart.data = chartConfig.data;
            this.chart.options = chartConfig.options || {};
            this.chart.update('none');
        },
        refresh() {
            if (this.chart) {
                this.chart.update('none');
            }
        }
    }
};
</script>
